import type { SetConsentTracking } from "@tandemdiabetes/sugarmate-api-react-client"
import { useSetConsentTracking } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useConsents } from "./useConsents"
import { noticeError } from "src/utils"

// Extract the parameter type from SetConsent
type SetConsentParameters = Parameters<SetConsentTracking>[0]

export function useUpdateConsents() {
  const setConsent = useSetConsentTracking()
  const { mutate } = useConsents()

  return useMemo(
    () => setConsent &&
      (async (consents: SetConsentParameters) => {
        try {
          const response = await setConsent(consents)

          void mutate(response.data.consent_tracking)
          return response
        } catch (e) {
          noticeError(
            e,
            "SetConsents",
            { consents },
          )

          throw e
        }
      }),
    [
      setConsent,
      mutate,
    ],
  )
}
